export const ORDER_FORM_TRANSLATION_DE = {
  settlement_type: 'Auftragstyp',
  attendances: 'Leistungen',
  startAt: 'Gültig von',
  endAt: 'Gültig bis',
  organization: 'Organisation',
  caregiver: 'Haupthelfer',
  language_preference: 'gewünschte Sprachkenntnisse',
  has_gender_preference: 'Es gibt eine Geschlechtspräferenz',
  gender: 'Geschlecht',
  has_pet_preference: 'Mitversorgung von Haustieren',
  pets: 'Art der Haustiere',
  planned_frequency: 'Geplantes Stundenvolumen',
  rhythm: 'Rhythmus',
  visits: 'Besuche',
  duration: 'Dauer pro Besuch',
  notes: 'Hinweise für die Auftragsplanung',
} as const;
